import * as wjcCore from '@grapecity/wijmo';

import { Component, OnInit, ViewChild } from '@angular/core';

import { NgbModal, ModalDismissReasons, NgbRadioGroup, NgbButtonsModule } from '@ng-bootstrap/ng-bootstrap';

import { AlertService } from '../service/alert.service';
import { SysMsg } from '../class/sysmsg';
import { GolfService } from '../service/golf.service';
import { UserService } from '../service/user.service';
import { Golf, GolfUser } from '../class/golf';
import { ModalWaitComponent } from '../modal-wait/modal-wait.component'
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-golf-mod',
  templateUrl: './golf-mod.component.html',
  styleUrls: ['./golf-mod.component.css'],
  providers: [GolfService, UserService]
})
export class GolfModComponent implements OnInit {
  data: wjcCore.CollectionView;
  currentItem = new GolfUser();
  public actives: any;
  public actives_cb = [];
  public work_kbns: any;
  public work_kbns_cb = [];
  public user_flgs_cb = [{cd: '0', name: '無'}, {cd: '1', name: '有'},];
  constructor(
    private golfService: GolfService,
    private userService: UserService,
    private alertService: AlertService,
    private modalService: NgbModal,
    public activeModal: NgbActiveModal
  ) { }

  ngOnInit() {
    sessionStorage.setItem('screen_id', 'golf-mod');
    this.currentItem.active = '1';
  }

  async regist() {
    const mw = this.modalService.open(ModalWaitComponent, {backdrop: 'static', keyboard: false});
    let continued = true;
    if (this.currentItem.user_flg == '1') {
      // role 4　はゴルフ場
      await this.userService.add(this.currentItem.username, this.currentItem.password, 4).then(result => {
        console.log(result);
        this.currentItem.user_id = result['id'];
      }).catch(error => {
        // TODO message を表示
        console.log(error.status);
        continued = false;
      });
    }
    if(!continued) {
      mw.close();
      return;
    }
    this.golfService.add(this.currentItem).then(result => {
      console.log(result);
      if (result.msgcd=='S') {
        this.currentItem.id = result.id;
        this.currentItem.userinfo_id = result['userinfo_id'];
        this.currentItem.modified = result['modified'];
        this.alertService.success(result.message, false);
        this.activeModal.close(this.currentItem);
      }else {
        this.alertService.error(result.message, false);
      }
      mw.close();
    });
  }
/*  
  chkUnique() {
    let c = this.currentItem;
    let filtered = this.data.items.filter(function (value,index,items) {
      if (c==value) {
        return false;
      }
      return (value.golf_cd == c.golf_cd)
    });
    console.log(filtered.length);
    return (filtered.length == 0);
  }
*/
  async update() {
    const mw = this.modalService.open(ModalWaitComponent, {backdrop: 'static', keyboard: false});
    let continued = true;
    // ユーザー登録されていない
    if (this.currentItem.user_id == 0) {
      if (this.currentItem.user_flg == '1') {
        // role 4　はゴルフ場
        await this.userService.add(this.currentItem.username, this.currentItem.password, 4).then(result => {
          console.log(result);
          this.currentItem.user_id = result['id'];
        }).catch(error => {
          // TODO message を表示
          console.log(error.status);
          continued = false;
        });
      }
    // ユーザー登録されている
    } else {
      if (this.currentItem.user_flg == '0') {
        //this.userService.delete(this.currentItem.user_id); // TODO ユーザー削除処理
        this.currentItem.user_id = 0;
      }
    }
    if(!continued) {
      mw.close();
      return;
    }
    this.golfService.update(this.currentItem).then(result => {
      if (result.msgcd=='S') {
        this.currentItem.userinfo_id = result['userinfo_id'];
        this.currentItem.modified = result['modified'];
        this.alertService.success(result.message, false);
        this.activeModal.close(this.currentItem);
      }else {
        this.alertService.error(result.message, false);
      }
      mw.close();
    });

  }
}
